export const NOTIFICATION_STREAMS = Object.freeze({
  alerts: "alerts",
  bonds: "bonds",
  conversations: "conversations",
  events: "events",
});

const NOTIFICATION_STREAM_TYPES = Object.freeze({
  [NOTIFICATION_STREAMS.alerts]: new Set([
    "admin_broadcast",
    "comment",
    "mention",
    "react",
    "subclan_invite",
    "subclan_post",
    "support_ticket",
    "workspace_update",
  ]),
  [NOTIFICATION_STREAMS.bonds]: new Set([
    "follow",
    "friend",
    "friend_request",
    "friend_accepted",
  ]),
  [NOTIFICATION_STREAMS.conversations]: new Set(["call", "message"]),
  [NOTIFICATION_STREAMS.events]: new Set(["calendar", "event"]),
});

export function getNotificationStream(notificationOrType) {
  const rawStream =
    typeof notificationOrType === "string"
      ? ""
      : notificationOrType?.stream || notificationOrType?.notificationStream;
  const stream = `${rawStream || ""}`.trim().toLowerCase();
  if (Object.prototype.hasOwnProperty.call(NOTIFICATION_STREAMS, stream)) {
    return stream;
  }

  const rawType =
    typeof notificationOrType === "string"
      ? notificationOrType
      : notificationOrType?.type;
  const type = `${rawType || ""}`.trim().toLowerCase();

  if (!type) return NOTIFICATION_STREAMS.alerts;

  const match = Object.entries(NOTIFICATION_STREAM_TYPES).find(([, types]) =>
    types.has(type)
  );
  return match?.[0] || NOTIFICATION_STREAMS.alerts;
}

export function isNotificationStream(notificationOrType, stream) {
  return getNotificationStream(notificationOrType) === stream;
}
